import * as keyapis_telemetry_control_v1_building_pb from "./v1/keyapis_telemetry_control_building_v1.pb";
import * as keyapis_telemetry_control_v1_device_pb from "./v1/keyapis_telemetry_control_device_v1.pb";
import * as keyapis_telemetry_control_v1_dictionary_pb from "./v1/keyapis_telemetry_control_dictionary_v1.pb";
import * as keyapis_telemetry_control_v1_events_pb from "./v1/keyapis_telemetry_control_events_v1.pb";
import * as keyapis_telemetry_control_v1_metric_point_pb from "./v1/keyapis_telemetry_control_metric_point_v1.pb";
import * as keyapis_telemetry_control_v1_stream_pb from "./v1/keyapis_telemetry_control_stream_v1.pb";
import * as keyapis_telemetry_control_v1_system_pb from "./v1/keyapis_telemetry_control_system_v1.pb";
import * as keyapis_telemetry_control_v1_template_pb from "./v1/keyapis_telemetry_control_template_v1.pb";

export default {
  v1: {
    resources: {
      building: keyapis_telemetry_control_v1_building_pb,
      device: keyapis_telemetry_control_v1_device_pb,
      dictionary: keyapis_telemetry_control_v1_dictionary_pb,
      events: keyapis_telemetry_control_v1_events_pb,
      metricPoint: keyapis_telemetry_control_v1_metric_point_pb,
      stream: keyapis_telemetry_control_v1_stream_pb,
      system: keyapis_telemetry_control_v1_system_pb,
      template: keyapis_telemetry_control_v1_template_pb,
    },
  },
};
